<template>
  <div class="contactus-mian">
    <div class="cantactus-box">
      <img
        class="contact_us_title"
        style="margin-bottom: 16px;"
        src="../assets/img/contact_us_title.png"
        alt=""
      />
      <div>
        <div style="width:55%;float:left">
          <div class="us-list">
            <div class="title-us">单位名称：</div>
            <div>
              <p>江西省人居环境研究院</p>
            </div>
          </div>
          <div class="us-list">
            <div class="title-us">单位地址：</div>
            <div>江西省南昌市东湖区二七北路610号</div>
          </div>
          <div class="us-list">
            <div class="title-us">联系电话：</div>
            <div style="flex:1;">
              <p>培训业务电话：0791-88103081</p>
              <p>考务业务电话：0791-88105590</p>
              <p>财务出纳电话：0791-88106931</p>
              <!-- <p>网站服务电话：400-999-9355</p> -->
            </div>
          </div>
          <div class="us-list">
            <div class="title-us">邮编地址：</div>
            <div>
              <p>邮政编码：330077</p>
              <p>建议邮箱：jxct@urdt.cn</p>
              <!-- <p>网站网址：http://jx.zhujianpeixun.com</p> -->
            </div>
          </div>
        </div>
        <div style="width:40%;float:left">
          <a @click="TiaoZhuan">
            <img
              style="width:315px;height: 205px"
              src="../assets/img/DiTu.jpg"
              alt=""
            />
          </a>
          <!-- <h1>123123123123123123</h1> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // url:'https://ditu.so.com/?k=%E5%8D%97%E6%98%8C%E5%B8%82%E7%BA%A2%E8%B0%B7%E6%BB%A9%E5%8C%BA%E5%BA%90%E5%B1%B1%E5%8D%97%E5%A4%A7%E9%81%931659%E5%8F%B7&src=onebox'
      url:
        "https://map.360.cn/?k=%E6%B1%9F%E8%A5%BF%E7%9C%81%E5%8D%97%E6%98%8C%E5%B8%82%E4%B8%9C%E6%B9%96%E5%8C%BA%E4%BA%8C%E4%B8%83%E5%8C%97%E8%B7%AF610%E5%8F%B7&src=onebox"
    };
  },
  methods: {
    TiaoZhuan() {
      window.open(this.url, "_blank");
    }
  }
};
</script>

<style lang="less">
@import url("../assets/css/main.less");
</style>



// WEBPACK FOOTER //
// src/components/Contactus.vue